import { PermissionString } from "../constants/permissions";

export const checkForPermission = (user, permission: PermissionString): boolean => {
    // if user has events:read:iat and we want events:read:iat
    return user?.permissions?.includes(permission);
};
